webpackJsonp([149816075995465],{

/***/ 352:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"html":"<p>Slides for a lightning talk about “Event-Driven” Architectures.</p>\n<p>Yes, it's still Serverless.</p>\n<iframe src=\"https://docs.google.com/presentation/d/e/2PACX-1vQVUdobBhQhuC0VPWHoHE0z0RVRLs2KCfSY69GeQ__QFarfNNuCXVhRMncJ-53J8n3X6URx44gHzHNY/embed?start=false&loop=false&delayms=3000\" frameborder=\"0\" width=\"960\" height=\"749\" allowfullscreen=\"true\" mozallowfullscreen=\"true\" webkitallowfullscreen=\"true\"></iframe>\n<hr>\n<h3>My references</h3>\n<ul>\n<li><a href=\"https://github.com/gesposito\">gesposito</a> on GitHub</li>\n<li><a href=\"https://twitter.com/_gesposito\">_gesposito</a> on Twitter</li>\n</ul>","frontmatter":{"title":"The case for “Event-Driven” Architectures"}}},"pathContext":{"slug":"event-driven/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---event-driven-90b3249ab0d9512d7f7c.js